import styled from "styled-components";
import { motion } from "motion/react";
import { AppTheme } from "../../../../theme";
declare module "styled-components" {
  export interface DefaultTheme extends AppTheme {}
}
export const BackgroundBottomBar = styled(motion.div)`
  width: 100%;
  display: flex;
  background: ${(props) => props.theme.MSBackground};
  position: absolute;
  bottom: 0;
  left: 0;
  box-shadow: ${(props) => props.theme.standardBoxShadow};
  padding: 4px 6px;
  justify-content: space-between;
  align-items: center;
  z-index: 99000;
`;

export const StartArea = styled.div`
  position: relative;
  flex-shrink: 0;
`;

export const BackgroundBottomBarStartButton = styled.button<{
  $pressed?: boolean;
}>`
  display: flex;
  background: ${(props) => props.theme.MSBackground};
  font-weight: bold;
  box-shadow: ${(props) => props.theme.standardBoxShadow};
  padding: 2px 10px;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border: none;
  margin-right: 4px;
  cursor: pointer;
  ${(props) =>
    props.$pressed &&
    `box-shadow: ${props.theme.invertedStandardBoxShadow};
     background: ${props.theme.MSBackgroundLight};`}
  &:active {
    box-shadow: ${(props) => props.theme.invertedStandardBoxShadow};
  }
`;

export const BackgroundBottomBarStartButtonIcon = styled.img`
  width: 30px;
  height: 30px;
`;

export const BackgroundBottomBarTimeContainer = styled.div`
  font-size: ${(props) => props.theme.fontNormal}px;
`;

export const BackgroundBottomBarTray = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  box-shadow: ${(props) => props.theme.invertedStandardBoxShadow};
  flex-shrink: 0;
`;

export const BackgroundBottomBarTrayButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  line-height: 1;
  padding: 2px;
`;

export const BackgroundBarInvitationIconContainer = styled(
  motion.div
).withConfig({
  shouldForwardProp: (prop) => prop !== "active",
})<{
  active: boolean;
}>`
  min-width: 35px; /* Width of icon + padding */
  max-width: 150px; /* Maximum width when there's space */
  width: 150px; /* Default width */
  padding: 4px 8px;
  box-shadow: ${(props) =>
    props.active
      ? props.theme.invertedStandardBoxShadow
      : props.theme.standardBoxShadow};
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: ${(props) => props.theme.fontNormal}px;
  background: ${(props) =>
    props.active ? props.theme.white : props.theme.MSBackground};
  cursor: pointer;

  overflow: hidden;
  white-space: nowrap;

  /* flex shrink to make space for other items */
  flex-shrink: 1;
`;

export const BackgroundBarInvitationIcon = styled.img`
  width: 25px;
  height: 25px;
  flex-shrink: 0; /* never shrinks */
`;

export const BackgroundBarInvitationText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;

export const BackgroundBarStartAndInviteContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  flex: 1; /* Take available space */
  overflow: hidden; /* Prevent container overflow */
  min-width: 0; /* Allow shrinking */
`;
